import { render, staticRenderFns } from "./EventsTable.vue?vue&type=template&id=3f73b720&scoped=true"
import script from "./EventsTable.vue?vue&type=script&lang=js"
export * from "./EventsTable.vue?vue&type=script&lang=js"
import style0 from "./EventsTable.vue?vue&type=style&index=0&id=3f73b720&prod&lang=scss"
import style1 from "./EventsTable.vue?vue&type=style&index=1&id=3f73b720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f73b720",
  null
  
)

export default component.exports